import React, { useEffect } from "react";
import codeimg from "../../../assets/images/code.svg";
import { getSession } from "../../../Slices/sessionSlice";
import { useDispatch } from "react-redux";
import "./PageNotFound.css";
function PageNotFound() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getSession());
  }, [dispatch]);

  return (
    <div className="pagenotfound-container  ">
      <div className="row">
        <div className="col-sm-4">
          <img src={codeimg} alt="codeimage" />
        </div>
        <div className="col-sm-8">
          <div className="heading">Oops!</div>
          <div className="error-body">
            <p className="message">
              We can't find the page you're looking for.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PageNotFound;
